import { Box } from "@mui/material";

type Props = {
  children: React.ReactNode;
};

export const Placeholder = ({ children }: Props) => {
  return (
    <Box
      sx={{
        height: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </Box>
  );
};
